import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const url = `${API_ENDPOINT}/api/v1`;

const auditTrailService = {
  list,
  detail,
  domainList,
};

function list(options = {}) {
  const { page, size, objectName, dateFrom, dateTo, value } = options;
  const params = {
    size: size ? size : 10,
    page: page ? page : 1,
    value: value ? value : '' // its like a must have in query params, if its removed then the content response would be empty
  };

  if (objectName) params.objectName = objectName;
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  // if (value) params.value = value;

  return submit('GET', `${url}/audit_log`, params, {});
}

function detail(options = {}){
  const { objectName, revNumber, primaryKeyEntity, type } = options;
  const params = {
    objectName: objectName ? objectName : '',
    revNumber: revNumber ? revNumber : '',
    primaryKeyEntity: primaryKeyEntity ? primaryKeyEntity : '',
    type: type ? type : '',
  };
  return submit('GET', `${url}/audit_log/detail`, params, {});
}

function domainList(){
  return submit('GET', `${url}/audit_log/audit_groups/groupA`, {});
}

export default auditTrailService;
